module.exports = __webpack_public_path__ + "static/img/bgscimg5back4.7c8a4b3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rppghealth/bgscimg5back4.png
// module id = 73Hi
// module chunks = 5